// extracted by mini-css-extract-plugin
export default {"l_SearchIcon_main":"SearchIcon_l_SearchIcon_main__gs5Q-","l_SearchIcon_iconImg":"SearchIcon_l_SearchIcon_iconImg__sq6bS"};